/**
 * Devuelve una función para añadir en un addEventListener.
 * La tecnica de "event delegation",
 * permite ahorar `EventListener`
 * y ademas simplifica la gestión de eventos.
 *
 *
 * @example lista con x repeticiones,
 * -> solo añadimos un EventListener
 * -> y centralizamos multiples acciones.
 *
 * ```html
 * <ul id="list">
 *   <li>
 *     <span index="0">Fila 1</span>
 *     <button action="add">Añadir</button>
 *     <button action="delete">Borrar</button>
 *   </li>
 *   <li>
 *     <span index="1">Fila 2</span>
 *     <button action="add">Añadir</button>
 *     <button action="delete">Borrar</button>
 *   </li>
 *   ...
 * </ul>
 * ```
 *
 * ```js
 * const onClick = onDelegation('action', {
 *   'add': (event, target) => { console.log('click en boton add:', target); },
 *   'delete': (event, target) => { console.log('click en boton delete', target); },
 * });
 *
 * document.getElementById('list').addEventListener('click', onClick);
 * ```
 *
 * @example EwcButton con submenu, también funciona
 * ```html
 * <ewc-button mode="menu" action="clickPrimary">
 *   <ewc-button action="clickSubmenu1"></ewc-button>
 *   <ewc-button action="clickSubmenu2"></ewc-button>
 *   ...
 * </ewc-button>
 * ```
 *
 * @param {string} attributeName el nombre del atributo que buscaremos, ej. "action"
 * @param {Object} actions el objeto con la lista de acciones, ej. { "actionName": event => {}, }
 * @returns {Function(event, target)} función con el evento original y el target donde se encontro el atributo
 */
export function onDelegation(attributeName, actions) {
  return event => {
    /**
     * Para los EwcButton mode="menu",
     * si se ha hecho click en un botón del submenu,
     * el botón original, del submenu, se pasa en el event.detail.target.
     * Entonces, miramos primero si existe, sino pillamos el target normal, event.target
     */
    const eventTarget = event?.detail?.target ?? event.target;
    const target = eventTarget.closest(`[${attributeName}]`);
    const action = target ? target.getAttribute(attributeName) : false;

    if (typeof actions?.[action] === 'function') {
      event.stopPropagation(); // para que se ejecute solo el primer eventDelegation
      actions[action](event, target);
    }
  };
}
